'use client';
const objectKeys = (object)=>Object.keys(object);
const objectValues = (object)=>Object.values(object);
const objectEntries = (object)=>Object.entries(object);
const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

export { getOwnPropertyDescriptor, objectEntries, objectKeys, objectValues };
//# sourceMappingURL=object.js.map
